import { useState } from 'react'
import Button from 'react-bootstrap/Button'

const DelayActionButton = ({
  onAction,
  delayTimeMs,
  displayText,
  confirmDisplayText,
  disabled,
  ...buttonProps
}) => {
  const [confirmAction, setConfirmAction] = useState(false)
  const [actionDisabled, setActionDisabled] = useState(false)

  return (
    <Button
      disabled={actionDisabled || disabled}
      onClick={_e => {
        if (confirmAction) {
          onAction()
          setConfirmAction(false)
          setActionDisabled(false)
        } else {
          setActionDisabled(true)
          setConfirmAction(true)
          // Re-enable button after a delay
          setTimeout(() => {
            setActionDisabled(false)
          }, delayTimeMs)
        }
      }}
      {...buttonProps}
    >
      {actionDisabled && (
        <span
          className="spinner-border spinner-border-sm me-1"
          role="status"
          aria-hidden="true"
        />
      )}
      {confirmAction ? confirmDisplayText : displayText}
    </Button>
  )
}

export default DelayActionButton
